<div class="booble-backdrop">

  <div class=" xp-modal xp-modal-cadastro">
    <div class="modal-dialog modal-xl modal-dialog-centered modal--xl modal--lg modal--md modal--sm">
      <div class="modal-content">
        <div class="modal-header">
          <div class="col-md-12">
            <div class="header-title">Adicionar invoice existente: Recebimento</div>
            <p class="header-subtitle">Insira as informações abaixo para anexar sua invoice existente.</p>
          </div>
          <button type="button" (click)="closeModal()" class="btn-close" data-dismiss="modal"
            aria-label="Close"></button>
        </div>
        <div class="modal-body">

          <div class="modal-dialog-scrollable-general">
          <div class="form tpl-form-2 pt-0">

            <form [formGroup]="orderForm">

              <div class="form-row">

                <div class="col-md-12">
                  <div class="form-subtitle">Informações para a ordem</div>
                </div>

                <div class="col-lg-4 col-md-6">
                  <div class="line">
                    <div class="label">Nome do Pagador<span class="text-danger"> *</span></div>
                    <input formControlName="companyName" type="text" class="form-control" name="" required />
                    <span class="text-danger"
                      *ngIf="(orderFormControl.companyName.touched) && orderFormControl.companyName.errors?.required">
                      Nome do pagador obrigatório
                    </span>
                  </div>
                </div>
 
                <div class="col-lg-4 col-md-6">
                  <div class="line">
                    <div class="label">CPF/CNPJ do Recebedor<span class="text-danger"> *</span></div>
                    <select formControlName="branch" placeholder="Selecione" class="js-control-branch custom-select">
                      <option *ngFor="let branch of branchs" [ngValue]="branch">
                        {{branch}}
                      </option>
                    </select>
                  </div>
                </div>

                <div class="col-lg-4 col-md-6">
                  <div class="line">
                    <div class="label">E-mail do Pagador<span class="text-danger"> *</span></div>
                    <input (keyup)="changeEmailForm()" formControlName="email" type="text" class="form-control" name="" required />
                    <span class="text-danger"
                      *ngIf="(orderFormControl.email.touched) && orderFormControl.email.errors?.required">
                      E-mail do pagador obrigatório
                    </span>
                  </div>
                </div>

                <div class="col-lg-2 col-md-6">
                  <div class="line">
                    <div class="label">Valor<span class="text-danger"> *</span></div>
                    <input formControlName="amount"
                      (blur)="orderFormControl.amount.value < 0 ? orderFormControl.amount.setValue(0) : orderFormControl.amount.value; orderFormControl.amount.value >= 999999 ? orderFormControl.amount.setValue(999999) : orderFormControl.amount.value;"
                      type="text" currencyMask [options]="{ prefix: '', thousands: '.', decimal: ',' }"
                      class="form-control" name="" required />
                    <span class="text-danger"
                      *ngIf="(orderFormControl.amount.touched) && orderFormControl.amount.errors?.required">
                      Valor obrigatório
                    </span>
                  </div>
                </div>

                <div class="col-lg-2 col-md-6">
                  <div class="line">
                    <div class="label">Moeda<span class="text-danger"> *</span></div>
                    <select placeholder="Selecione" formControlName="currency" class="custom-select js-control-currency"
                      name="currency">
                      <option value="USD">USD</option>
                      <option value="EUR">EUR</option>
                      <option value="GBP">GBP</option>
                      <option value="CAD">CAD</option>
                      <option value="CHF">CHF</option>
                    </select>
                  </div>
                </div>

                <div class="col-lg-2 col-md-6">
                  <div class="line">
                    <div class="label">País<span class="text-danger"> *</span></div>
                    <select placeholder="Selecione" name="" [value]="orderForm.controls.country"
                      formControlName="country" class="custom-select js-control-country">
                      <option *ngFor="let country of countries" [ngValue]="country.nome">
                        {{country.nome}}
                      </option>
                    </select>
                  </div>
                </div>

                <div class="col-lg-6 col-md-6">
                  <div class="line">
                    <div class="label">Finalidade<span class="text-danger"> *</span></div>
                    <select formControlName="finalityId" placeholder="Selecione"
                      class="js-control-finality custom-select">
                      <option *ngFor="let finality of finalities" [ngValue]="finality.id">
                        {{finality.description}}
                      </option>
                    </select>
                  </div>
                </div>

                <div class="col-md-12">

                </div>
              </div>

              <div class="dashboard-line-btn">

                <div class="form-row form-invoice">

                  <div class="cols">
                    <div class="form-group mb-0">
                      <button (click)="openNewOrderModal()" type="button" class="btn-xp-m2 btn-gray-new">
                        Voltar
                      </button>
                    </div>
                  </div>

                  <div class="cols col-md-12 col-lg-6 col-pc">
                    <div class="mb-xl-0 mb-2">

                      <label class="custom-checkbox-1 square">Enviar detalhes da ordem para
                        pagador
                        <input type="checkbox" [checked]="orderFormControl.copyinvoiceemail.value"
                          (change)="handleCopyinvoiceemail($event)">
                        <span id="checkmark-invoice" class="checkmark"></span>
                      </label>
                    </div>
                  </div>
                  <div class="cols">
                    <div class="form-group mb-0">
                      <button [ngClass]="{'btn-gray-disabled': orderForm.invalid , 'btn-blue-30': !orderForm.invalid}"
                        [disabled]="orderForm.invalid || loading" (click)="sendExistingInvoice()" type="button"
                        class="btn-xp-m2 btn-blue-30">
                        Avançar
                        <span class="spinner-border spinner-border-sm" *ngIf="loading"></span>
                      </button>
                    </div>
                  </div>

                </div>

              </div>
            </form>
          </div>
        </div>
        </div>
      </div>
    </div>
  </div>
</div>
